export const WorkOrderRouting = [
  {
    path: "/maintenanceSetting/workOrder",
    name: "maintenanceSetting-workOrder-list",
    meta: { title: "工单类型" },
    component: () =>
      import(
        /* webpackCh`un`kName: "maintenanceSetting-workPackage" */ "@/views/maintenance/workOrder/list/index.vue"
      ),
  },
];
